import { Modal, SubmitButton } from "@xola/ui-kit";
import { FormField, InputField, requiredString, TextareaField } from "common";
import { produce } from "immer";
import React from "react";
import { ProductCatalogItem } from "types";
import { object, string } from "yup";
import { SecondaryButton } from "../../Common/SecondaryButton";
import { XolaFormik } from "../../Common/XolaFormik";

interface EditCatalogItemProps {
    name: string;
    caption: string;
}

const validationSchema = object({
    name: requiredString(),
    caption: string(),
});

interface EditCatalogItemModalProps {
    isOpen: boolean;
    catalogItem: ProductCatalogItem;
    onSubmit: (catalogItem: ProductCatalogItem) => void;
    onClose: (event: any) => void;
}

export const EditCatalogItemModal = ({ isOpen, catalogItem, onSubmit, onClose }: EditCatalogItemModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalContent catalogItem={catalogItem} onSubmit={onSubmit} onClose={onClose} />
        </Modal>
    );
};

type ModalContentProps = Omit<EditCatalogItemModalProps, "isOpen">;

const ModalContent = ({ catalogItem, onSubmit, onClose }: ModalContentProps) => {
    const initialValues: EditCatalogItemProps = {
        name: catalogItem?.name ?? "",
        caption: catalogItem?.caption ?? "",
    };

    const handleSubmit = async (values: EditCatalogItemProps) => {
        const updatedCatalogItem = produce(catalogItem, (draft) => {
            draft.caption = values.caption;
            draft.overrideParent = true;
        });

        onSubmit(updatedCatalogItem);
    };

    return (
        <XolaFormik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({ handleSubmit, dirty }) => (
                <>
                    <Modal.Header>Edit Demographic</Modal.Header>

                    <Modal.Body>
                        <fieldset className="space-y-6">
                            <FormField name="name" label="Name">
                                <InputField disabled isRequired placeholder="Name" />
                            </FormField>

                            <FormField name="caption" label="Caption">
                                <TextareaField rows={5} placeholder="Caption" />
                            </FormField>
                        </fieldset>
                    </Modal.Body>

                    <Modal.Footer>
                        <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
                        <SubmitButton disabled={!dirty} onClick={handleSubmit}>
                            Save
                        </SubmitButton>
                    </Modal.Footer>
                </>
            )}
        </XolaFormik>
    );
};
